import { useEffect, useState } from 'react';

export default function useA2HS() {
  const [promptEvent, setPromptEvent] = useState(null);
  const [isStandalone, setIsStandalone] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    setIsStandalone(
      window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true
    );
    setIsIos(/iphone|ipad|ipod/i.test(window.navigator.userAgent));
  }, []);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setPromptEvent(e);
    };
    const onInstalled = () => {
      localStorage.setItem('a2hs-installed', '1');
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const installed =
    isStandalone || localStorage.getItem('a2hs-installed') === '1';

  const promptInstall = async () => {
    if (!promptEvent) return { outcome: 'unavailable' };
    promptEvent.prompt();
    const { outcome } = await promptEvent.userChoice;
    setPromptEvent(null);
    if (outcome === 'accepted') {
      localStorage.setItem('a2hs-installed', '1');
    }
    return { outcome };
  };

  return { installed, canPrompt: !!promptEvent, promptInstall, isIos };
}
